import styled from 'styled-components';

import { COLORS, DESKTOP } from '../../../../theme/tokens';
import { Text } from '../../../../components';

export const Categories = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Category = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0;
`;

export const CategoryHead = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const CategoryTitle = styled(Text)`
  font-size: 15px;
  color: ${COLORS.text};
`;

export const CategoryHint = styled(Text)`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;

/** The row of channel toggles (Email / SMS / Push) for one category. */
export const Channels = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const Channel = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ChannelLabel = styled(Text)`
  font-size: 13px;
  color: ${COLORS.featureName};
`;

export const Divider = styled.div`
  height: 1px;
  margin: 16px 0;
  background: ${COLORS.hairline};
`;

export const SaveError = styled(Text)`
  font-size: 13px;
  color: ${COLORS.statusDanger};
`;

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;

  ${DESKTOP} {
    align-items: center;
    border-top: 1px solid ${COLORS.hairline};
    padding-top: 20px;

    && > * {
      width: 50%;
    }
  }
`;
